import type { MouseEventHandler } from "react";

import { memo } from "react";

import { type UUID } from "crypto";

import { hapticFeedback, popup } from "@telegram-apps/sdk-react";
import { Address } from "@ton/core";

import { useTranslation } from "@arc/i18n";
import { trimAddress, useNetwork, useTonWallets } from "@arc/sdk";
import { LogoutIcon } from "@arc/ui/icons/logout";
import { ListItem } from "@arc/ui/list-item";

export const WalletItem = memo(
  ({ id, address, title, version }: { id: UUID; address: string; title: string; version: string }) => {
    const { t } = useTranslation("wallet");
    const { network } = useNetwork();

    const humanizedAddress = Address.parse(address).toString({ testOnly: network === "testnet", bounceable: false });

    const trimmedAddress = trimAddress(humanizedAddress);
    const { disconnectWallet, selectWallet } = useTonWallets();

    const handleDisconnectWallet: MouseEventHandler<SVGSVGElement> = (e) => {
      e.stopPropagation();
      popup
        .open({
          title: t("WALLET_LIST.ASK_DISCONNECT"),
          message: t("WALLET_LIST.ASK_DISCONNECT_MESSAGE"),
          buttons: [
            { id: "disconnect", type: "destructive", text: t("WALLET_LIST.ASK_DISCONNECT_DISCONNECT") },
            { id: "cancel", type: "default", text: t("UI.CANCEL") },
          ],
        })
        .then((buttonId) => {
          if (buttonId === "disconnect") {
            disconnectWallet(id);
          }
        });
    };

    const handleSelectWallet = () => {
      hapticFeedback.impactOccurred("medium");
      selectWallet(id);
    };

    return (
      <ListItem
        leftBottomText={trimmedAddress}
        leftTopText={`${title} (${version})`}
        rightIcon={<LogoutIcon className="stroke-negative fill-none" onClick={handleDisconnectWallet} />}
        rightTopText="&nbsp;" // можно баланс выводить
        onClick={handleSelectWallet}
      />
    );
  },
);

WalletItem.displayName = "WalletItem";
